import { Paginator } from "./paginator";

export interface ArrayRenderStrategyOptions {
  pageSize: number;
}

export class ArrayRenderStrategy {
  public static withFullRender(): ArrayRenderStrategy {
    return new ArrayRenderStrategy({
      pageSize: Infinity
    });
  }

  public static withPartialRender(pageSize: number): ArrayRenderStrategy {
    return new ArrayRenderStrategy({
      pageSize
    });
  }

  private _paginator: Paginator;
  public get paginator(): Paginator {
    return this._paginator;
  }

  constructor(private options: ArrayRenderStrategyOptions) {
    this._paginator = new Paginator(options.pageSize);
  }

  public get pageSize(): number {
    return this.options.pageSize;
  }
}
